export default "__VITE_ASSET__DgJn6mtd__"